import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkReturnPurchaseDelete = commonConfirmationBulkDelete('ReturnPurchase');
export default BulkReturnPurchaseDelete;
